import { Schedule, DateInput, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { SectionTitle } from '../../../../../../components/text';
import CourseTypeLegends from '../../../../../../packages/parts/CourseTypeLegends';
import { TimeModuleType } from '../../../../../../types/timeModuleTypes';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { AcademicOfferScheduleSection } from '../../../types';
import { useAcademicOfferWeeklyCalendar } from '../../../hooks/useAcademicOfferWeeklyCalendar';

interface AcademicOfferCalendarProps {
  sections: AcademicOfferScheduleSection[];
  modules: TimeModuleType[];
  legends: { id: number; name: string }[];
}

export function AcademicOfferCalendar({
  sections,
  modules,
  legends,
}: AcademicOfferCalendarProps) {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );

  const {
    selectedWeek,
    nextWeek,
    previousWeek,
    selectWeek,
    schedules,
    datesWithEvents,
    days,
  } = useAcademicOfferWeeklyCalendar(sections);

  return (
    <Row>
      <Col xs={6}>
        <SectionTitle text={t('schedule.title')} />
      </Col>

      <Col xs={12}>
        {/* Navegación semanal */}
        <Row className="d-flex align-items-center mx-0 my-2">
          <span onClick={previousWeek} className="cursor-pointer">
            <Icon className="mr-4" name="chevron_left" />
          </span>
          <span onClick={nextWeek} className="cursor-pointer">
            <Icon name="chevron_right" />
          </span>
          <Col
            xs={1}
            className="fs-20 text-uppercase text-primary fw-700 mb-0 ml-4"
          >
            <Row>{selectedWeek.start.format('MMMM')}</Row>
            <Row>{selectedWeek.start.format('YYYY')}</Row>
          </Col>
          <Col xs={3}>
            <DateInput
              label={t('schedule.viewCalendar')}
              name="weekSelector"
              value={selectedWeek.selectedDay.format()}
              onChange={(date) => selectWeek(date)}
              datesWithEvents={datesWithEvents}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={12}>
        <Schedule
          mobileNavigation
          days={days}
          schedules={schedules}
          modules={modules}
        />
      </Col>
      <Col xs={12} className="pt-5">
        <CourseTypeLegends legends={legends} />
      </Col>
    </Row>
  );
}
